import React, { useState } from "react";

const newsImages = [
  // Replace these with your actual image paths in the src/assets or src/news folder
  require("../assets/news1.jpg"),
  require("../assets/news2.jpg"),
  require("../assets/news3.jpg"),
  require("../assets/news4.jpg"),
  require("../assets/news5.jpg"),
  require("../assets/news6.jpg"),
  require("../assets/news7.jpg"),
  require("../assets/news8.jpg"),
];

const FeaturedNews: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeImgIdx, setActiveImgIdx] = useState<number | null>(null);

  const openModal = (imgIdx: number) => {
    setActiveImgIdx(imgIdx);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveImgIdx(null);
  };

  const showPrev = () => {
    setActiveImgIdx((prev) => {
      if (prev === null) return null;
      const total = newsImages.length;
      return (prev - 1 + total) % total;
    });
  };

  const showNext = () => {
    setActiveImgIdx((prev) => {
      if (prev === null) return null;
      const total = newsImages.length;
      return (prev + 1) % total;
    });
  };

  // Close modal on background click
  const handleModalBgClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) closeModal();
  };

  return (
    <section className="section-padding bg-white min-h-screen">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Featured in the News
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Our work and impact have been recognized by leading newspapers and
            media outlets. Here are some highlights from our journey as covered
            in the press.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {newsImages.map((img, idx) => (
            <div
              key={idx}
              className="bg-light rounded-lg overflow-hidden shadow-md cursor-pointer"
              onClick={() => openModal(idx)}
            >
              <img
                src={img}
                alt={`Newspaper cutting ${idx + 1}`}
                className="w-full h-64 object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal Lightbox */}
      {modalOpen && activeImgIdx !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 transition-all"
          onClick={handleModalBgClick}
        >
          <button
            className="absolute top-6 right-8 text-white text-3xl font-bold focus:outline-none"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>
          <button
            className="absolute left-4 md:left-12 text-white text-4xl font-bold px-2 py-1 focus:outline-none"
            onClick={showPrev}
            aria-label="Previous image"
          >
            &#8592;
          </button>
          <img
            src={newsImages[activeImgIdx]}
            alt="Enlarged news"
            className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-2xl border-4 border-white"
          />
          <button
            className="absolute right-4 md:right-12 text-white text-4xl font-bold px-2 py-1 focus:outline-none"
            onClick={showNext}
            aria-label="Next image"
          >
            &#8594;
          </button>
        </div>
      )}
    </section>
  );
};

export default FeaturedNews;
